import React, { createContext, ReactNode, useContext } from 'react';
import { TenantRuntime } from './types';

const TenantContext = createContext<TenantRuntime | undefined>(undefined);

export type TenantProviderProps = {
  tenant: TenantRuntime;
  children: ReactNode;
};

export const TenantProvider: React.FC<TenantProviderProps> = ({ tenant, children }) => (
  <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
);

export const useTenant = (): TenantRuntime => {
  const tenant = useContext(TenantContext);
  if (!tenant) {
    throw new Error('useTenant must be used within a TenantProvider.');
  }
  return tenant;
};

/**
 * Founder-only control-plane routes can render before a tenant is selected.
 * Tenant-owned features must continue to use useTenant() so missing context
 * fails closed instead of silently selecting another business.
 */
export const useOptionalTenant = (): TenantRuntime | undefined => useContext(TenantContext);
